export domain from './domain';

export const getChartCode = () => {
  //获取A~Z字段
  var arr = [];
  for (var i = 65; i < 91; i++) {
    arr.push(String.fromCharCode(i));
  }
  return arr;
}

export const getNameFirstWord = name => {
  //获取name中的首字母
  const key = name.substring(0, 1) || '';
  return key;
}

//用于接口请求失败后，展示的数据
export const hotData = [
  {
    "name": "中国内地（大陆）",
    "codeShow": "+86",
    "codeValue": "",
    "pinyin": "zhongguo",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  },
  {
    "name": "中国香港",
    "codeShow": "+852",
    "codeValue": "00852",
    "pinyin": "zhongguoxianggan",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  },
  {
    "name": "中国澳门",
    "codeShow": "+853",
    "codeValue": "00853",
    "pinyin": "zhongguoaomen",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  },
  {
    "name": "中国台湾",
    "codeShow": "+886",
    "codeValue": "00886",
    "pinyin": "zhongguoaomen",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  },
  {
    "name": "美国",
    "codeShow": "+1",
    "codeValue": "001",
    "pinyin": "meiguo",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  },
  {
    "name": "加拿大",
    "codeShow": "+1",
    "codeValue": "001",
    "pinyin": "jianada",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  },
  {
    "name": "新加坡",
    "codeShow": "+65",
    "codeValue": "0065",
    "pinyin": "xinjiapo",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  },
  {
    "name": "澳大利亚",
    "codeShow": "+61",
    "codeValue": "0061",
    "pinyin": "aodaliya",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  },
  {
    "name": "英国",
    "codeShow": "+44",
    "codeValue": "0044",
    "pinyin": "yingguo",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  },
  {
    "name": "马来西亚",
    "codeShow": "+60",
    "codeValue": "0060",
    "pinyin": "malaixiya",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  },
  {
    "name": "韩国",
    "codeShow": "+82",
    "codeValue": "0082",
    "pinyin": "hanguo",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  },
  {
    "name": "法国",
    "codeShow": "+33",
    "codeValue": "0033",
    "pinyin": "faguo",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  },
  {
    "name": "新西兰",
    "codeShow": "+64",
    "codeValue": "0064",
    "pinyin": "xinxilan",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  },
  {
    "name": "德国",
    "codeShow": "+49",
    "codeValue": "0049",
    "pinyin": "deguo",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  },
  {
    "name": "日本",
    "codeShow": "+81",
    "codeValue": "0081",
    "pinyin": "riben",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  },
  {
    "name": "西班牙",
    "codeShow": "+34",
    "codeValue": "0034",
    "pinyin": "xibanya",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  },
  {
    "name": "意大利",
    "codeShow": "+39",
    "codeValue": "0039",
    "pinyin": "yidali",
    "regex": "/^[0-9]{6,16}$/",
    "regex4ios": "^[0-9]{6,16}$"
  }
]